import { closeModal } from '../modal/modal';
import './user-form.scss';
import { sendFormSubmitted } from '../../assets/js/tracking/eventsTracking';

(($) => {
	$(`#${'send-button'}`).on('click', function () {
		const formData = getFormData();
		localStorage.setItem('formData', JSON.stringify(formData));
		const iterableData = getIterableData();
		localStorage.setItem('iterableData', JSON.stringify(iterableData));
		closeModal('user-form-modal', false);
	});

	const closeButton = $('#close-user-form-modal');
	closeButton.on('click', () => {
		closeModal('user-form-modal', false);
	});

	const checkFormItems = (formItems) => {
		const sendButton = document.querySelector('#send-button');
		if (sendButton) {
			let allFilled = true;
			formItems.forEach((item) => {
				if (item.type === 'checkbox' || item.type === 'radio') {
					const name = item.name;
					const checked = [...formItems].some(
						(i) => i.name === name && i.checked,
					);
					if (!checked) allFilled = false;
				} else if (!item.value) allFilled = false;
			});
			sendButton.disabled = !allFilled;
		}
	};
	const formItems = document.querySelectorAll(
		'.user-form--questionsConatiner input',
	);

	formItems.forEach((item) => {
		item.addEventListener('change', () => {
			checkFormItems(formItems);
		});
	});

	// Initial check
	checkFormItems(formItems);
})(jQuery);

const getFormData = () => {
	const checkboxResults = getCheckboxResults();
	const radioResults = getRadioResults();
	const combinedResults = [...checkboxResults, ...radioResults];
	return combinedResults;
};

const getCheckboxResults = () => {
	const fields = [];
	// Select all checkboxes with the class 'user-form-checkbox--input'
	const checkboxes = document.querySelectorAll('.user-form-checkbox--input');

	checkboxes.forEach((checkbox) => {
		// Get the label associated with the checkbox
		const label = document.querySelector(`label[for='${checkbox.id}']`);
		const field = {
			autofilled: false,
			fieldId: checkbox.id,
			fieldLabel: label.dataset.question,
			fieldName: checkbox.value,
			fieldType: 'radiobutton',
			fieldValue: checkbox.checked.toString(),
		};
		fields.push(field);
	});

	return fields;
};

const getRadioResults = () => {
	const fields = [];
	const radioButtons = document.querySelectorAll('.user-form-radio--input');

	radioButtons.forEach((radioButton) => {
		const label = document.querySelector(`label[for='${radioButton.id}']`);

		const field = {
			autofilled: false,
			fieldId: radioButton.id,
			fieldLabel: label.dataset.question,
			fieldName: radioButton.value,
			fieldType: 'radiobutton',
			fieldValue: radioButton.checked.toString(),
		};
		fields.push(field);
	});
	return fields;
};

const getIterableData = () => {
	const checkboxResults = getCheckboxResultsIterable();
	const radioResults = getRadioResultsIterable();
	return { ...checkboxResults, ...radioResults };
};

const getCheckboxResultsIterable = () => {
	return getInputData('.user-form-checkbox--input');
};

const getRadioResultsIterable = () => {
	return getInputData('.user-form-radio--input');
};

const getInputData = (inputClass) => {
	const jsonObject = {};
	const btns = document.querySelectorAll(inputClass);

	btns.forEach((btn) => {
		const label = document.querySelector(`label[for='${btn.id}']`);
		if (label.dataset.trait) {
			jsonObject[label.dataset.trait] = btn.checked;
		}
	});

	return jsonObject;
};

export const handleUserFormSubmission = (email) => {
	const formData = getStoredFormData();
	if (formData) {
		// Send data to the server
		sendUserFormSubmittedEvent(formData);
		// Clear the form data
		localStorage.removeItem('formData');
	}
	const iterableData = getStoredIterableData();
	if (iterableData) {
		updateUserOnIterable(email, iterableData);
		localStorage.removeItem('iterableData');
	}
};

const sendUserFormSubmittedEvent = (formData) => {
	const payload = {
		formType: 'questionaire',
		formName: document.getElementById('user-form-heading').innerText,
		formId: 'user-form',
		captureType: 'Custom Form',
		capturePlacement: 'Modal',
		valueProp: 'Personalized Content',
		field: formData,
	};
	sendFormSubmitted(payload);
};

const getStoredFormData = () => {
	const storedFormData = localStorage.getItem('formData');
	if (storedFormData) {
		return JSON.parse(storedFormData);
	}
	return null;
};

const getStoredIterableData = () => {
	const stored = localStorage.getItem('iterableData');
	if (stored) {
		return JSON.parse(stored);
	}
	return null;
};

export const updateUserOnIterable = (email, dataFields) => {
	fetch(window.location.origin + '/wp-json/email/v1/users/update', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			email,
			dataFields,
		}),
	});
};
